import { useState } from "react";
import { useNavbarHeight } from "../../utils/contexts/NavbarContext";
import { scrollToIdWithOffset } from "../../lib/scrolling/ScrollToIdWithOffset";

interface ChildProps {
    message: string;
}

function DismissableBanner( { message } : ChildProps) {
  const [visible, setVisible] = useState(true);
  const { navbarHeight } = useNavbarHeight();

  if (!visible) return null;

  return (
    <div 
    className="dismissable-banner fixed-top alert alert-danger alert-dismissible fade show mb-0 rounded-0 d-flex justify-content-between align-items-center"
    style={{ top: `${navbarHeight}px`}}>
      <div className="d-flex justify-content-center align-items-center w-100">
        <a
        className="nav-link"
        href="#openingHours"
        onClick={(e) => {
          setVisible(false);
          scrollToIdWithOffset("openingHours", e, navbarHeight);
        }}>
          {message}
        </a>
      </div>

      <button
      type="button"
      className="btn-close"
      onClick={() => setVisible(false)}
      aria-label="Close"></button>
    </div>
  );
}

export default DismissableBanner;